import { useTranslation } from "react-i18next";

import Modal from "../../layouts/Modal";
import ImageCarousel from "../shared/Images/ImageCarousel";

export interface IDamageViewerImage {
  id: string;
  url: string;
  fileName: string;
}

type Props = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  categoryName: string | null;
  images: IDamageViewerImage[];
};

/**
 * Lightweight viewer for the Damage AI annotated images of a single category,
 * opened from the "Damaged" pill on the parts categories table.
 */
export default function DamageImagesModal({ open, setOpen, categoryName, images }: Props) {
  const { t } = useTranslation("jobs");

  return (
    <Modal open={open} setOpen={setOpen} width="max-w-4xl">
      <div className="space-y-3" onClick={(e) => e.stopPropagation()}>
        <div className="pr-8">
          <h3 className="text-lg font-semibold text-slate-900">
            {t("Damage AI")} — {categoryName}
          </h3>
          <p className="text-xs text-slate-500">{t("Powered by Tractable")}</p>
        </div>

        {images.length > 0 ? (
          <ImageCarousel images={images} part={true} size="w-48 h-48" />
        ) : (
          <p className="text-sm text-slate-500">{t("No damage images available for this category.")}</p>
        )}
      </div>
    </Modal>
  );
}
